import AutoModeIcon from '@mui/icons-material/AutoMode';
import { IconButton, Stack, TextField } from '@mui/material';

import { uuid } from '@@common';

type GuidInputProps = {
	value: string | null | undefined;
	onValueChange: (value: string) => void;
	variant?: 'standard' | 'outlined' | 'filled';
};

export default function GuidInput({ value, onValueChange, variant = 'standard' }: GuidInputProps) {
	return (
		<Stack direction="row" spacing={1} sx={{ flexGrow: 1, flexShrink: 1 }}>
			<TextField variant={variant} type="text" value={value ?? ''} onChange={(e) => onValueChange(e.target.value)} sx={{ flexGrow: 1, flexShrink: 1 }} />
			<IconButton title="Generate New Guid" onClick={() => onValueChange(uuid())}>
				<AutoModeIcon />
			</IconButton>
		</Stack>
	);
}
